import { Component, Input } from "@angular/core";

@Component({
  selector: "ab-route-method",
  templateUrl: "./route-method.component.html",
})
export class RouteMethodComponent {
  @Input() public method: string;
}
